import { Link, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import React from 'react';

import { UserForm } from '@/components/organisms/UserForm';
import { baseRoles } from '@/data/roles';
import { CreateUserFormData, UpdateUserFormData } from '@/DTOs/users';
import { useTranslator } from '@/hooks/useTranslator';

interface RoleDescriptor {
  readonly value: string;
  readonly name: string;
  readonly description: string;
}

interface Props {
  readonly error?: 'user.conflict' | 'activeUser.conflict' | null;
  onSubmit(data: CreateUserFormData | UpdateUserFormData): Promise<void>;
}

export const CreateUserForm: React.FC<Props> = (props: Props): React.ReactElement => {
  const { error, onSubmit } = props;
  const [showRoles, setShowRoles] = React.useState<boolean>(false);

  const tr = useTranslator();

  const toggleShowRoles = React.useCallback((): void => {
    setShowRoles((showRoles: boolean): boolean => !showRoles);
  }, []);

  return (
    <UserForm error={error} submitText="INVITE" loading={false} onSubmit={onSubmit}>
      <Box px={4}>
        <Link onClick={toggleShowRoles}>
          <Typography variant="body2" color="primary">
            {showRoles ? tr('HIDE_ROLE_DETAILS') : tr('SHOW_ROLE_DETAILS')}
          </Typography>
        </Link>
      </Box>
      <List>
        {showRoles &&
          baseRoles.map(
            (role: RoleDescriptor): React.ReactElement => (
              <ListItem key={role.value}>
                <Box display="grid" gridTemplateColumns="16px 1fr">
                  <Box display="flex" alignItems="center" justifyContent="flex-start" height={24}>
                    <Box bgcolor="text.primary" width={6} height={6} borderRadius={8} />
                  </Box>
                  <Box flex={1}>
                    <Typography variant="body2">
                      <Typography component="span">{tr(role.name)}</Typography>
                      <Typography color="custom.LightGray" component="span">
                        : {tr(role.description)}
                      </Typography>
                    </Typography>
                  </Box>
                </Box>
              </ListItem>
            ),
          )}
      </List>
    </UserForm>
  );
};
